<template>
	<div>
		<div v-for="menu in categorizedMenu" :key="menu.menuId">
			<div
				v-for="category in menu.categories"
				:key="category.categoryId"
				:id="`category-section-${category.categoryId}`"
				ref="category-section"
				class="desktop-center"
			>
				<div
					v-if="category.categoryId != -1"
					:ref="`category-${category.categoryId}`"
					class="menu-section-title"
					@click="toggleCategory(category.categoryId, menu.menuId)"
				>
					<!-- <span> -->
					<!-- <button
							class="filter hamburger-icon"
							@click="
								!minimizedCategories[
									`${category.categoryId}_${menu.menuId}`
								]
							"
						>
							<i class="sk-icon-list-ul-solid"></i>
						</button> -->
					<!-- </span> -->
					{{ category.categoryName }}
					<span class="category-item-count">
						{{ category.items.length }}
					</span>
					<i
						class="sk-icon-chevron-up flipable"
						:class="{
							flipped:
								!minimizedCategories[
									`${category.categoryId}_${menu.menuId}`
								]
						}"
					></i>
				</div>
				<transition-expand>
					<div
						class="menu-items desktop-center"
						v-if="
							!minimizedCategories[
								`${category.categoryId}_${menu.menuId}`
							]
						"
					>
						<MenuItem
							v-for="(item, i) in category.items"
							:key="`${item.id}-${i}}`"
							:item="item"
							:data-cy="`menu-item-${item.id}`"
						/>
					</div>
				</transition-expand>
			</div>
		</div>
	</div>
</template>

<style scoped>
.menu-section-title {
	margin-left: -9px !important;
	padding-top: 25px;
	cursor: pointer;
	display: flex;
	align-items: center;
	font-size: 14px;
}

@media only screen and (max-width: 1600px) {
	.menu-section-title {
		margin-left: -2px !important;
	}
}

.menu-section-title .category-item-count {
	margin-left: 10px;
	color: var(--gR-base-80);
	font-size: 10px;
}

.menu-section-title .sk-icon-chevron-up {
	margin-left: auto;
}
/* .hamburger-icon {
	padding-top: 5px;
	padding-right: 20px;
	background-color: var(--sk-grey1);
} */
</style>

<script>
import MenuItem from "@/components/menu/MenuItem.vue"
import TransitionExpand from "@/components/common/TransitionExpand.vue"

export default {
	name: "CategorizedMenu",
	components: {
		MenuItem,
		TransitionExpand
	},
	props: {
		categorizedMenu: {
			type: Array,
			default: () => []
		}
	},
	data: function () {
		return {
			minimizedCategories: {}
		}
	},
	methods: {
		toggleCategory(categoryId, menuId) {
			const id = `${categoryId}_${menuId}`
			if (this.minimizedCategories[id]) {
				this.minimizedCategories[id] = false
			} else {
				this.$set(this.minimizedCategories, id, true)
			}
		}
	}
}
</script>